var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable, makeObservable } from 'mobx';
import { runtime } from '../../runtime/Runtime';
export class AnsweringStepMistake {
    parent;
    dateOfLastMistake;
    numberOfMistakes = 0;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    trackMistake() {
        this.dateOfLastMistake = runtime.runtimeClock.currentDate;
        this.numberOfMistakes++;
    }
    hadMistakeInRecentMilliseconds(milliSeconds) {
        if (!this.dateOfLastMistake)
            return false;
        return runtime.runtimeTimeSwitch.forTime(this.dateOfLastMistake.getTime() + milliSeconds).isBelow;
    }
    get showMistakeFeedback_1500ms() {
        return this.hadMistakeInRecentMilliseconds(1500);
    }
    get showMistakeFeedback_500ms() {
        return this.hadMistakeInRecentMilliseconds(500);
    }
}
__decorate([
    observable
], AnsweringStepMistake.prototype, "dateOfLastMistake", void 0);
__decorate([
    observable
], AnsweringStepMistake.prototype, "numberOfMistakes", void 0);
__decorate([
    action
], AnsweringStepMistake.prototype, "trackMistake", null);
__decorate([
    computed
], AnsweringStepMistake.prototype, "showMistakeFeedback_1500ms", null);
__decorate([
    computed
], AnsweringStepMistake.prototype, "showMistakeFeedback_500ms", null);
